module.exports = __webpack_public_path__ + "media/images/wimmer-bc4edb75c21c5adc105fdc0eccebe11d.png";